import SmartPhone from "./SVG/smartPhone.svg?react";

const SmartPhoneIcon = () => {
  return <SmartPhone />;
};

export default SmartPhoneIcon;
